import StructureOptions from "./StructureOptions";
import MicroscopyTemplateThumbnail from "./MicroscopyTemplateThumbnail";
export default function TemplatePreview({
  key,
  template,
  expansion,
  templateDispatch,
}){

  let { channelGroupStructure } = template.compact;


  return (

    <div class="sg-row rel" style={{ 
        justifyContent:'center',
        zIndex:0,
        pointerEvents:'none',
        marginRight:20,
        }}>

      


        <div>
          <h4>Template</h4>

          <div style={{
            marginLeft:30,
            marginRight:30,
          }} class="sg-row v-center">
          {channelGroupStructure && <StructureOptions {...{templateDispatch}} value={channelGroupStructure}/>}
            <div class="flex-expand"/>
            <div>
              Other options
            </div>
          </div>



        <div style={{
          border:'1px solid #ccc',
          background:'#fafafa',
          pointerEvents:'auto',

        }} class="small-padding fair-margin round-corners rel sg-row h-center">
          {true && <MicroscopyTemplateThumbnail
            onEvent={event => {
              console.log(event);

              if( event.type === "dispatch" ){

                templateDispatch(event.properties);
              
              }else if( event.type === "templateNodeChannelChange" ){

                debugger;

                let { nodeId, properties } = event;
                let newChannels = {
                  ...template.compact.channels,
                  [nodeId]:{ 
                    ...template.compact.channels[nodeId],
                    ...properties,
                    //colors:value 
                  }
                }
                templateDispatch({channels:newChannels});
              }
            }}
            //key={Math.random()} 
            template={expansion} 
            templateId={key}
          />}
        </div>
        </div>
      </div>
  )
}
